import { StateSetter } from './react';
import { SDKEngagement } from './sdk';

export interface EngagementContextType {
  engagement: SDKEngagement | undefined;
  setEngagement: StateSetter<SDKEngagement | undefined>;
  initEngagement: () => void
  closeEngagement: () => void
  resetEngagement: () => void
  activateHistoryMode: () => void
  isActive: ()=>boolean
  engagementStatus: EngagementStatus
  isConnected:()=>boolean
  isHistory:()=>boolean
  setEngagementStatus: StateSetter<EngagementStatus>
}

export interface EngagementStatus {
  retrieved: boolean
  closed: boolean
  history: boolean
}
export const engagementStatusDefault: EngagementStatus = {
  closed: true,
  retrieved: false,
  history: false
}